import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';
import { type DayGroup } from '@/shared/config';
import { groupByDay } from '@/shared/lib';

import { getEncounterDate } from '@/entities/transcriptor';

export type EncounterGroup = DayGroup<TranscriptorEncounterResponse>;

export const groupEncountersByDay = (
  encounters: TranscriptorEncounterResponse[],
): EncounterGroup[] => groupByDay(encounters, getEncounterDate);
